import { IllumioEventEmitter } from "../common/event_emitter.js";
import IllumioSupportForm from "../common/support_form.js";

export class KnowledgeBaseDownloadModel extends IllumioEventEmitter {
    constructor() {
        super();
    }
}

export class KnowledgeBaseDownloadView extends IllumioEventEmitter {
    constructor(model) {
        super();

        this.model = model;

        this.kbDownloadForm = document.getElementById('kbDownloadForm');
        console.debug(this.kbDownloadForm);
    }
}

export class KnowledgeBaseDownloadController extends IllumioEventEmitter {
    constructor(model, view) {
        super();

        this.model = model;
        this.view = view;

        // Initalize the download form
        const kbFiles = document.getElementById('kbFiles');
        if (kbFiles && this.view.kbDownloadForm) {
            const anchorElements = kbFiles.getElementsByTagName('A');
            for (const anchorElement of anchorElements) {
                if (anchorElement.dataset.id) {
                    anchorElement.onclick = this.downloadAnchorElementOnClickHandler.bind(this);
                }
            }
        }

        this.view.kbDownloadForm.onsubmit = this.kbDownloadFormOnSubmitHandler.bind(this);
        // console.debug(this.view.kbDownloadForm.onsubmit);
        
        const csrf = IllumioSupportForm.getCsrf();
        if (csrf) {
            this.view.kbDownloadForm['authenticity_token'].value = csrf.authenticity_token;
        }
    }

    /**
     * Known issue - this method is not invoked when  <element>.submit().
     * @param {*} event 
     */
    kbDownloadFormOnSubmitHandler(event) {
        event.preventDefault();

        console.debug(`kbDownloadFormOnSubmitHandler()`);
    }

    downloadAnchorElementOnClickHandler(event) {
        console.debug(`downloadAnchorElementOnClickHandler()`);
        console.debug(event);
        event.preventDefault();
        if (event.target.dataset.id) {
            this.view.kbDownloadForm['asset_id'].value = event.target.dataset.id;
            this.view.kbDownloadForm.submit();
            console.debug(`Submit kb download form`);
        } else {
            console.error(`Cannot submit the download form due to missing dataset id!`);
        }
    }
}